import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import { RiFileChartLine } from "react-icons/ri";
import { Table } from "reactstrap";
import {
    formatMoney,
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const KPI_COLUMNS = [
    { key: 'year', title: 'Year', format: (v) => v ?? '-' },
    { key: 'revenue', title: 'Revenue', format: (v) => formatMoney(v) },
    { key: 'net_income', title: 'Net Income', format: (v) => formatMoney(v) },
    { key: 'employees', title: 'Employees', format: (v) => (v ?? '-') },
    { key: 'active_total', title: 'Total Assets', format: (v) => formatMoney(v) },
    { key: 'material_expenses', title: 'Material Expenses', format: (v) => formatMoney(v) },
    { key: 'personnel_expenses', title: 'Personnel Expenses', format: (v) => formatMoney(v) },
];

const FinancialKpi = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const rows = data?.financial_kpi || [];

    if (!hasNonEmptyArray(rows)) {
        return null;
    }

    const sorted = [...rows].sort((a, b) => (b?.year || 0) - (a?.year || 0));

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('financial-kpi')}
            className={activeAccordion === 'financial-kpi' ? 'active' : ''}
            eventKey={'financial-kpi'}
        >
            <Accordion.Header>
                <RiFileChartLine size={20} className="me-2" />
                <span>{t('Financial KPIs')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                {KPI_COLUMNS.map((col) => (
                                    <th key={col.key}>{t(col.title)}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {sorted.map((row, index) => (
                                <tr key={row.year || index}>
                                    {KPI_COLUMNS.map((col) => (
                                        <td key={col.key}>{col.format(row[col.key])}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(FinancialKpi);
